import type { RouteRecordRaw } from 'vue-router';

import CrudActionType from '@/features/crud/CrudActionType';

const CampaignsPage = async () => import('@/pages/CampaignsPage.vue');
const CampaignFormPage = async () => import('@/pages/CampaignFormPage.vue');
const CampaignsMassEditModal = async () =>
  import('@/features/campaigns/campaigns-mass-edit-modal/CampaignsMassEditModal.vue');

export default function getCampaignsRoutes(): RouteRecordRaw[] {
  return [
    {
      name: 'campaigns',
      alias: '/campaigns',
      children: [
        {
          name: 'edit-many-campaigns',
          component: CampaignsMassEditModal,
          path: String.raw`edit/mass/:ids(\d+)+`,
          props: (route) => ({
            campaignIds: route.params.ids,
          }),
        },
      ],
      component: CampaignsPage,
      meta: {
        title: 'Campaigns',
        useIn: ['navigation-tabs'],
      },
      path: '/',
    },
    {
      name: 'create-campaign',
      component: CampaignFormPage,
      meta: {
        title: 'Create campaign',
      },
      path: '/campaigns/create',
      props: {
        action: {
          type: CrudActionType.CREATE,
        },
      },
    },
    {
      name: 'edit-campaign',
      component: CampaignFormPage,
      meta: {
        title: 'Edit campaign',
      },
      path: '/campaigns/edit/:id',
      props: (route) => ({
        action: {
          id: route.params.id,
          type: CrudActionType.EDIT,
        },
      }),
    },
    {
      name: 'clone-campaign',
      component: CampaignFormPage,
      meta: {
        title: 'Clone campaign',
      },
      path: '/campaigns/clone/:id',
      props: (route) => ({
        action: {
          id: route.params.id,
          type: CrudActionType.CLONE,
        },
      }),
    },
  ];
}
